import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

// Manual serialization (e.g. units built before this feature existed, or lines with no WO).
export const NewSerialRunDialog = ({ api, open, onOpenChange, templates, productOptions, preset, onCreated }) => {
  const [f, setF] = useState({ product_key: '', quantity: 1, template_id: '', customer: '' });
  useEffect(() => { if (open) setF({ product_key: '', quantity: preset ? '' : 1, template_id: '', customer: '' }); }, [open, preset]);
  const go = async () => {
    try {
      const body = preset ? { ...preset, quantity: Number(f.quantity) || undefined, template_id: f.template_id || undefined }
        : { source_type: 'manual', product_key: f.product_key, quantity: Number(f.quantity), template_id: f.template_id || undefined, customer: f.customer || undefined };
      const r = await api().post('/serial-runs', body);
      toast.success(`Created ${r.data.units.length} serial(s)`); onCreated(r.data); onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not serialize'); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="new-serial-run-dialog">
        <DialogHeader><DialogTitle>{preset ? `Serialize ${preset.label}` : 'Serialize units'}</DialogTitle></DialogHeader>
        {!preset && <div><Label>Product SKU / key *</Label><Input value={f.product_key} onChange={(e) => setF({ ...f, product_key: e.target.value })} list="nsr-products" className="rounded-sm mono" data-testid="nsr-product-input" />
          <datalist id="nsr-products">{(productOptions || []).map(p => <option key={p} value={p} />)}</datalist></div>}
        <div><Label>Quantity{preset ? ' (blank = line quantity)' : ' *'}</Label><Input type="number" min={1} value={f.quantity} onChange={(e) => setF({ ...f, quantity: e.target.value })} className="rounded-sm" data-testid="nsr-qty-input" /></div>
        <div><Label>Faceplate template</Label>
          <select value={f.template_id} onChange={(e) => setF({ ...f, template_id: e.target.value })} className="w-full h-9 border border-slate-200 rounded-sm text-sm px-2" data-testid="nsr-template-select">
            <option value="">Auto (matches product)</option>{templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select></div>
        {!preset && <div><Label>Customer</Label><Input value={f.customer} onChange={(e) => setF({ ...f, customer: e.target.value })} className="rounded-sm" data-testid="nsr-customer-input" /></div>}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm" data-testid="nsr-cancel-btn">Cancel</Button>
          <Button onClick={go} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="nsr-submit-btn">Create serials</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default NewSerialRunDialog;
